<template>
  <div class="align-center text-color-secondary flex-row gap-3">
    <slot name="icon" />

    <OwnType :text="message" color="secondary" variant="title-regular" />
  </div>
</template>

<script lang="ts" setup>
import { OwnType } from '@/ui/OwnType'

defineProps<{
  message: string
}>()
</script>
